import { render, staticRenderFns } from "./Pills.vue?vue&type=template&id=03c16b70"
import script from "./Pills.vue?vue&type=script&lang=js"
export * from "./Pills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports